export enum DesignFeature {
  Header = 'header',
  NewLogo = 'new-logo',
  Fonts = 'fonts',
  NewIcons = 'new-icons',
}
